import { delData, getData, postData, patchData } from '../../../utils/fetch-api-util';
import { ShopType, SortShopsPayload, SHOP_TYPE, FormShopType } from '../../../types/shop';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface TileWidgetRequestParams {
  take?: number;
  page?: number;
  country?: string;
  type?: SHOP_TYPE;
  sort?: boolean;
}

export interface TileWidgetTypeResponse {
  widgets: ShopType[];
  total: number;
}

interface SuccessResponse {
  success: boolean;
}

export const getTileWidgetListRepository = async (data?: TileWidgetRequestParams): Promise<TileWidgetTypeResponse> => {
  const response = await getData<TileWidgetRequestParams, TileWidgetTypeResponse>(API_URLS.TILE_WIDGET_API, data);
  return response.data;
};

export const postCreateTileWidgetRepository = async (payload: FormShopType): Promise<void> => {
  await postData<FormShopType, SuccessResponse>(API_URLS.TILE_WIDGET_API, payload);
};

export const patchUpdateTileWidgetRepository = async (payload: ShopType): Promise<void> => {
  await patchData<ShopType, SuccessResponse>(API_URLS.TILE_WIDGET_URL_WITH_ID(payload?.id || ''), payload);
};

export const patchActiveTileWidgetRepository = async (payload: ShopType): Promise<void> => {
  await patchData<ShopType, SuccessResponse>(API_URLS.TILE_WIDGET_ACTIVE_URL_WITH_ID(payload?.id || ''), payload);
};

export const deleteTileWidgetRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.TILE_WIDGET_URL_WITH_ID(id));
};

export const postSortTileWidgetsRepository = async (payload: SortShopsPayload): Promise<void> => {
  await postData<SortShopsPayload, SuccessResponse>(API_URLS.TILE_WIDGET_SORT, payload);
};
